module.exports = __webpack_public_path__ + "static/media/ic_alian.fbb7ea4c.svg";